export class CoverageMhs {
    planName?: string;
    planCode: string;
    additionalAmount?: string;
    lifeCoverageStructure?: string;
    productLine: string;
    productName?: string;
    benefitWaitingPeriod?: string;
    benefitPercent?: string;
    cola?: boolean;
}